(function ($, DataTable) {
    "use strict";

    var _buildParams = function (dt, action, onlyVisibles) {
        var params = dt.ajax.params();
        params.action = action;
        params._token = $('meta[name="csrf-token"]').attr('content');

        if (onlyVisibles) {
            params.visible_columns = _getVisibleColumns();
        } else {
            params.visible_columns = null;
        }

        return params;
    };

    var _getVisibleColumns = function () {

        var visible_columns = [];
        $.each(DataTable.settings[0].aoColumns, function (key, col) {
            if (col.bVisible) {
                visible_columns.push(col.name);
            }
        });

        return visible_columns;
    };

    var _downloadFromUrl = function (url, params) {
        var postUrl = url + '/export';
        var xhr = new XMLHttpRequest();
        xhr.open('POST', postUrl, true);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function () {
            if (this.status === 200) {
                var filename = "";
                var disposition = xhr.getResponseHeader('Content-Disposition');
                if (disposition && disposition.indexOf('attachment') !== -1) {
                    var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                    var matches = filenameRegex.exec(disposition);
                    if (matches != null && matches[1]) filename = matches[1].replace(/['"]/g, '');
                }
                var type = xhr.getResponseHeader('Content-Type');

                var blob = new Blob([this.response], {type: type});
                if (typeof window.navigator.msSaveBlob !== 'undefined') {
                    // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
                    window.navigator.msSaveBlob(blob, filename);
                } else {
                    var URL = window.URL || window.webkitURL;
                    var downloadUrl = URL.createObjectURL(blob);

                    if (filename) {
                        // use HTML5 a[download] attribute to specify filename
                        var a = document.createElement("a");
                        // safari doesn't support this yet
                        if (typeof a.download === 'undefined') {
                            window.location = downloadUrl;
                        } else {
                            a.href = downloadUrl;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                        }
                    } else {
                        window.location = downloadUrl;
                    }

                    setTimeout(function () {
                        URL.revokeObjectURL(downloadUrl);
                    }, 100); // cleanup
                }
            }
        };
        xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        xhr.send($.param(params));
    };

    var _buildUrl = function(dt, action) {
        var url = dt.ajax.url() || '';
        var params = dt.ajax.params();
        params.action = action;

        if (url.indexOf('?') > -1) {
            return url + '&' + $.param(params);
        }

        return url + '?' + $.param(params);
    };

    function getUrlParameters() {
        let sPageURL = decodeURIComponent(window.location.search.substring(1)),
            sURLVariables = sPageURL.split('&'),
            sParameter,
            i;

        let params = {};
        for (i = 0; i < sURLVariables.length; i++) {
            if(sURLVariables[i] !== ''){
                sParameter = sURLVariables[i].split('=');
                params[sParameter[0]] = (sParameter[1] === undefined) ? true : sParameter[1];
            }
        }
        return params;
    }

    function getUrlParameter(search) {
        let params = getUrlParameters();
        if ($.inArray(params, search)){
            return params[search];
        }
    }

    function removeUrlParameter(param)
    {
        let params = getUrlParameters();
        let url = window.location.href.split('?')[0]+'?';

        $.each(params, function(k, v){
            if(k !== param){
                url = url + k + '=' + v + '&'
            }
        });
        return window.history.pushState(null, null, url.substring(0,url.length-1));
    }

    DataTable.ext.buttons.excel = {
        className: 'buttons-excel',

        text: function (dt) {
            return '<i class="fa fa-file-excel"></i> ' + dt.i18n('buttons.excel', 'Excel');
        },

        action: function (e, dt, button, config) {
            var url = _buildUrl(dt, 'excel');
            window.location = url;
        }
    };

    DataTable.ext.buttons.postExcel = {
        className: 'buttons-excel',

        text: function (dt) {
            return '<i class="fa fa-file-excel"></i> ' + dt.i18n('buttons.excel', 'Excel');
        },

        action: function (e, dt, button, config) {
            var url = dt.ajax.url() || window.location.href;
            var params = _buildParams(dt, 'excel');

            _downloadFromUrl(url, params);
        }
    };

    DataTable.ext.buttons.postExcelVisibleColumns = {
        className: 'buttons-excel',

        text: function (dt) {
            return '<i class="fa fa-file-excel"></i> ' + dt.i18n('buttons.excel', 'Excel (only visible columns)');
        },

        action: function (e, dt, button, config) {
            var url = dt.ajax.url() || window.location.href;
            var params = _buildParams(dt, 'excel', true);

            _downloadFromUrl(url, params);
        }
    };

    DataTable.ext.buttons.export = {
        extend: 'collection',

        className: 'buttons-export',

        text: function (dt) {
            return '<i class="fa fa-download"></i>&nbsp;<span class="caret"/>';
        },

        buttons: ['csv', 'excel', 'pdf']
    };

    DataTable.ext.buttons.csv = {
        className: 'buttons-csv',

        text: function (dt) {
            return '<i class="fa fa-file-excel"></i> ' + dt.i18n('buttons.csv', 'CSV');
        },

        action: function (e, dt, button, config) {
            var url = _buildUrl(dt, 'csv');
            window.location = url;
        }
    };

    DataTable.ext.buttons.postCsvVisibleColumns = {
        className: 'buttons-csv',

        text: function (dt) {
            return '<i class="fa fa-file-excel"></i> ' + dt.i18n('buttons.csv', 'CSV (only visible columns)');
        },

        action: function (e, dt, button, config) {
            var url = dt.ajax.url() || window.location.href;
            var params = _buildParams(dt, 'csv', true);

            _downloadFromUrl(url, params);
        }
    };

    DataTable.ext.buttons.postCsv = {
        className: 'buttons-csv',

        text: function (dt) {
            return '<i class="fa fa-file-excel"></i> ' + dt.i18n('buttons.csv', 'CSV');
        },

        action: function (e, dt, button, config) {
            var url = dt.ajax.url() || window.location.href;
            var params = _buildParams(dt, 'csv');

            _downloadFromUrl(url, params);
        }
    };

    DataTable.ext.buttons.pdf = {
        className: 'buttons-pdf',

        text: function (dt) {
            return '<i class="fa fa-file-pdf"></i> ' + dt.i18n('buttons.pdf', 'PDF');
        },

        action: function (e, dt, button, config) {
            var url = _buildUrl(dt, 'pdf');
            window.location = url;
        }
    };

    DataTable.ext.buttons.postPdf = {
        className: 'buttons-pdf',

        text: function (dt) {
            return '<i class="fa fa-file-pdf"></i>' + dt.i18n('buttons.pdf', 'PDF');
        },

        action: function (e, dt, button, config) {
            var url = dt.ajax.url() || window.location.href;
            var params = _buildParams(dt, 'pdf');

            _downloadFromUrl(url, params);
        }
    };

    DataTable.ext.buttons.print = {
        className: 'buttons-print',

        text: function (dt) {
            return  '<i class="fa fa-print"></i>';
        },

        action: function (e, dt, button, config) {
            var url = _buildUrl(dt, 'print');
            window.location = url;
        }
    };

    DataTable.ext.buttons.reset = {
        className: 'buttons-reset',

        text: function () {
            return '<i class="far fa-eraser"></i>';
        },

        action: function (e, dt) {
            dt.state.clear();
            window.location.replace(window.location.href.split('?')[0]);
        }
    };

    DataTable.ext.buttons.reload = {
        className: 'buttons-reload',

        text: function () {
            return '<i class="far fa-sync"></i>';
        },

        action: function (e, dt) {
            dt.draw('page');
        }
    };

    DataTable.ext.buttons.filters = {
        className: 'buttons-filters',

        text: function () {
            return '<i class="far fa-filter"></i>';
        },

        action: function () {
            $('.card-filters').fadeToggle();
        }
    };

    if (typeof DataTable.ext.buttons.copyHtml5 !== 'undefined') {
        $.extend(DataTable.ext.buttons.copyHtml5, {
            text: function (dt) {
                return '<i class="fa fa-copy"></i> ' + dt.i18n('buttons.copy', 'Copy');
            }
        });
    }

    if (typeof DataTable.ext.buttons.colvis !== 'undefined') {
        $.extend(DataTable.ext.buttons.colvis, {
            text: function (dt) {
                return '<i class="fa fa-eye"></i> ' + dt.i18n('buttons.colvis', 'Column visibility');
            }
        });
    }

    DataTable.preInit = function(table, settings){

        // init params
        let params = getUrlParameters();
        let card = $(table.table().container()).closest('.card');
        let add = card.find('button#add');
        let card_filters = card.find('.card-filters');

        if(typeof Object.keys(params).length !== "undefined" && Object.keys(params).length){
            $.each(settings.aoPreSearchCols, function(k){
                settings.aoPreSearchCols[k].sSearch = null;
            });
            settings.oPreviousSearch.sSearch = null;

            $.each(params, function(key, value){
                let columns = $.grep(settings.aoColumns, function(n){
                    return n.name === key;
                });

                if (columns.length && value) {
                    table.column(columns[0].idx).search(value);
                    settings.aoPreSearchCols[columns[0].idx].sSearch = value;
                }
            });
        }

        // temp
        $('button#filters').on('click', function(){
            card_filters.fadeToggle('fast');
        });

        $('button#refresh').on('click', function(){
            table.draw('page');
        });

        $('button#reset').on('click', function(){
            table.state.clear(); window.location.replace(window.location.href.split('?')[0]);
        });

        let visible = false;
        card_filters.find('[name^="filter"]').each(function(){
            let d = $(this);

            let column = d.data('target');
            let value = settings.aoPreSearchCols[column].sSearch;

            if (value) {
                d.findById(value);
                add.each(function(){
                    $(this).attr('data-'+settings.aoColumns[column].name, value);
                });
                visible = true;
            }

            d.on('change', function() {
                let value = $(this).val();
                table.column(column).search(value).draw('page');

                if(getUrlParameter(settings.aoColumns[column].name)){
                    removeUrlParameter(settings.aoColumns[column].name);
                }

                add.each(function(){
                    if(value){
                        $(this).attr('data-'+settings.aoColumns[column].name, value);
                    } else {
                        $(this).removeAttr('data-'+settings.aoColumns[column].name);
                    }
                });
            });
        });

        if(visible){
            card_filters.fadeIn();
        }
        // end temp

        $.each(settings.aoColumns, function(k,v){
            if(v.filter){
                let filter = $('<select>');

                if(v.filter['type'] === 'text'){
                    filter = $('<input>');
                    if(v.filter['data-placeholder']) {
                        filter.attr('placeholder', v.filter['data-placeholder']);
                    }
                } else {
                    if(v.filter['data-placeholder']){
                        filter.append($('<option/>').val(null).text(v.filter['data-placeholder']));
                    }
                }

                $.each(v.filter, function(q,w){
                    if(q === 'data'){
                        $.each(w, function(l,p){
                            filter.append($('<option/>').val(l).text(p));
                        });
                    } else {
                        filter.attr(q, w);
                    }
                });

                if(v.name){
                    filter.attr('id', v.name);
                }

                filter.attr('data-target', v.target);
                filters.push(filter);
            }
        });
    };
})(jQuery, jQuery.fn.dataTable);
